import React, { useState } from 'react';
import { Plus } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  q: 'Is this a physical book?',
  a: 'This is a digital book in high-quality PDF/EPUB format, optimized for reading on any device.'
}, {
  q: 'When will I receive it?',
  a: 'Immediately. Once payment is confirmed, an automated link is sent to your email for instant download.'
}, {
  q: 'Can I read it on my phone or tablet?',
  a: 'Yes, the file is compatible with all mobile devices, tablets, computers, and e-readers like Kindle.'
}, {
  q: 'Is this book journalism or opinion?',
  a: 'It is a rigorous historical and journalistic investigation based on facts, documents, and verified testimonies.'
}, {
  q: 'What is the refund policy?',
  a: 'We offer a 100% satisfaction guarantee. If the document does not meet your expectations, you can request a refund within the first 7 days.'
}];
function FAQItem({
  q,
  a,
  isOpen,
  onToggle
}: {
  q: string;
  a: string;
  isOpen: boolean;
  onToggle: () => void;
}) {
  return <div className="border-b border-gray-800" data-id="element-57">
      <button onClick={onToggle} className="w-full flex items-center justify-between gap-6 py-6 text-left group" data-id="element-58">
        <span className="font-serif text-lg sm:text-xl text-[#e8e2d4] group-hover:text-[#d4a85a] transition-colors font-normal" data-id="element-59">
          {q}
        </span>
        <motion.div animate={{
        rotate: isOpen ? 45 : 0
      }} transition={{
        duration: 0.3
      }} className="flex-shrink-0" data-id="element-60">
          <Plus className="w-5 h-5 text-[#DC2626]" strokeWidth={2.5} data-id="element-61" />
        </motion.div>
      </button>
      <AnimatePresence initial={false} data-id="element-62">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-63">
            <p className="text-gray-400 leading-relaxed pb-6 pr-12 font-light text-base" data-id="element-64">
              {a}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-[#0a0a0a] py-12 sm:py-20 px-6 border-t border-gray-900/60" data-id="element-65">
      <div className="max-w-3xl mx-auto" data-id="element-66">
        {/* Header */}
        <div className="text-center mb-16 flex flex-col items-center gap-6" data-id="element-67">
          <p className="text-[#d4a85a] uppercase tracking-[0.25em] text-[11px] sm:text-xs font-semibold" data-id="element-68">
            Frequently Asked Questions
          </p>

          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-[#e8e2d4] font-normal leading-tight" data-id="element-69">
            We resolve your doubts
          </h2>

          {/* Red-blue-gold divider */}
          <div className="h-px w-32" style={{
          background: 'linear-gradient(to right, #DC2626, #2563eb, #d4a85a)'
        }} data-id="element-70" />
        </div>

        {/* Accordion */}
        <div className="border-t border-gray-800" data-id="element-71">
          {faqs.map((faq, i) => <FAQItem key={i} q={faq.q} a={faq.a} isOpen={openIndex === i} onToggle={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-72" />)}
        </div>
      </div>
    </section>;
}